import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useT } from '../i18n';
import './Banner.css';

export function Banner() {
  const { t } = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return;
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    window.addEventListener('pointerdown', onClick);
    return () => window.removeEventListener('pointerdown', onClick);
  }, [open]);

  return (
    <header className="banner">
      <Link to="/" className="banner__brand" aria-label={t('brand.name')}>
        <span className="banner__wordmark">singlings</span>
        <span className="banner__version" title={`Build ${__BUILD_TIME__}`}>
          v{__APP_VERSION__}
        </span>
      </Link>
      <div className="banner__right" ref={ref}>
        <button
          className="banner__profile"
          aria-label={t('banner.profile')}
          aria-expanded={open}
          aria-haspopup="menu"
          onClick={() => setOpen((v) => !v)}
        >
          <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
            <circle cx="12" cy="8.5" r="4" fill="none" stroke="currentColor" strokeWidth="1.8" />
            <path d="M3.5 20c1.8-3.8 5-5.5 8.5-5.5s6.7 1.7 8.5 5.5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </button>
        {open && (
          <div className="banner__menu" role="menu">
            <button
              className="banner__menu-item"
              role="menuitem"
              onClick={() => {
                setOpen(false);
                navigate('/settings');
              }}
            >
              {t('banner.settings')}
            </button>
            <button
              className="banner__menu-item"
              role="menuitem"
              onClick={() => {
                setOpen(false);
                navigate('/profile');
              }}
            >
              {t('banner.profile')}
            </button>
            <div className="banner__menu-sep" />
            <button className="banner__menu-item banner__menu-item--disabled" role="menuitem" disabled>
              {t('banner.signInSoon')}
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
